import CustomButton from "../../CustomButton";
import classes from "./available-credits.module.css";
import cx from "classnames";
import { useRouter } from "next/router";
import { Routes } from "../../../routes/RouteConstants";
import CreditsExpire from "../../CreditExpire";
import { CREDITS_ON_HOLD } from "../../../services/constants";
import LogService from "../../../services/LogService";
import CREDIT_EVENTS from "../../../utils/CreditEvents";
import { numberWithCommas } from "../../../services/utils";
import CookieService from "../../../services/CookieService";
import { useCreditProfile } from "queries/credits/useCreditProfile";

function AvailableCredits(props) {
  const { isReservedTab } = props;
  const router = useRouter();
  const { query } = router;

  const { data: creditsData = {} } = useCreditProfile(query.recruiterId);

  const { totalAvailableCredits = null, holdCredits = null } = creditsData;
  const totalCredits = totalAvailableCredits + holdCredits;

  function onBuyCredits() {
    LogService.log(CREDIT_EVENTS.BUY_CREDITS_CLICKED, {
      source: "TRANSACTION-HISTORY"
    });

    const isNativeApp = CookieService.getCookie("is_native_app");

    if (isNativeApp) {
      window.open(`/hire${Routes.PLAN_SELECTION}`, "_blank");
      return;
    }
    router.push(Routes.PLAN_SELECTION);
  }

  function onReservedClick() {
    const queryParams = { tabId: CREDITS_ON_HOLD };
    router.push({
      pathname: Routes.TRANSACTION_HISTORY,
      query: queryParams
    });
    LogService.log(CREDIT_EVENTS.TH_RESERVED_CLICKED);
  }

  return (
    <>
      <div className={classes.root}>
        <div className={classes.creditsContainer}>
          <div className={classes.availableCreds}>
            <div>Available Balance</div>
            <div className={classes.balance}>
              <img
                src="/hire/coin-icon.svg"
                alt="coin-icon"
                height={32}
                width={32}
                className={classes.coinIcon}
              />
              {numberWithCommas(totalAvailableCredits)}
            </div>
          </div>
          {!isReservedTab && (
            <div className={classes.ctaContainer}>
              <CustomButton
                className={classes.buyCreditsCTA}
                onClick={onBuyCredits}
              >
                Add Credits
                <img
                  src="/hire/arrow-right.svg"
                  width={19}
                  height={19}
                  alt="arrow-right icon"
                  className={classes.arrowRight}
                />
              </CustomButton>
            </div>
          )}
        </div>
        {holdCredits ? (
          <div className={classes.creditsCardsContainer}>
            <div className={classes.creditsCard}>
              <div className={classes.creditsCount}>
                {numberWithCommas(totalCredits)}
              </div>
              <div className={classes.creditsLabel}>Total Balance</div>
            </div>

            <div
              className={cx(
                classes.creditsCard,
                isReservedTab ? classes.reservedCard : classes.clickCard
              )}
              onClick={!isReservedTab ? onReservedClick : null}
            >
              <div className={classes.creditsCount}>
                {numberWithCommas(holdCredits)}
              </div>
              <div className={classes.creditsLabel}>Reserved</div>
              {!isReservedTab && (
                <img
                  src="/hire/reserved-credits-arrow.svg"
                  width={16}
                  height={16}
                  alt="reserved-credits-arrow icon"
                  className={classes.reservedArrow}
                />
              )}
            </div>
          </div>
        ) : null}
      </div>
      {!isReservedTab && (
        <CreditsExpire
          customClass={classes.creditsExpireContainer}
          page="Transaction-History"
        />
      )}
    </>
  );
}

export default AvailableCredits;
